import { connect } from 'react-redux'

import AdminDashboard from 'app/bond_cover/admin/admin_dashboard'

export default connect()(AdminDashboard)
